/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Coaches_Page_Title_TailInputs */

const en_coaches_page_title_tail = /** @type {(inputs: Coaches_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`has time for you.`)
};

const pl_coaches_page_title_tail = /** @type {(inputs: Coaches_Page_Title_TailInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ma dla Ciebie czas.`)
};

/**
* | output |
* | --- |
* | "has time for you." |
*
* @param {Coaches_Page_Title_TailInputs} inputs
* @param {{ locale?: "en" | "pl" }} options
* @returns {LocalizedString}
*/
export const coaches_page_title_tail = /** @type {((inputs?: Coaches_Page_Title_TailInputs, options?: { locale?: "en" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Coaches_Page_Title_TailInputs, { locale?: "en" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pl") return pl_coaches_page_title_tail(inputs)
	return en_coaches_page_title_tail(inputs)
});